import NotificationActions from '../../../actions/NotificationActions';
import PrintActions from '../../../actions/PrintActions';
import PosActions from '../../../actions/PosActions';
import PopupActions from '../../../actions/PopupActions';

import UserStore from '../../../stores/UserStore';
import ConfigStore from '../../../stores/ConfigStore';

import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as PosEndPoints } from '../../../constants/PosConstants';
import { endPoints as UserEndPoints } from '../../../constants/UserConstants';

import ReturnForm from './ReturnForm.react';
import PrintLabel from './PrintLabel.react';
import PrintManifest from './PrintManifest.react';
import ChangePaymentTypeForm from './ChangePaymentTypeForm.react';
import EmailReceipt from '../../pos/checkout/EmailReceipt.react';

class Transaction extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading                 : true,
            transaction             : false,
            actions                 : false,
            pin                : '',
            selected                : false,
            showReturnForm          : false,
            showPrintLabel          : false,
            showActions             : false,
            showChangePaymentType   : false,
            showEmailReceipt        : false,
            suppressVoidTxn         : false,
        };

        this.close = this.close.bind(this);
        this.voidTransaction = this.voidTransaction.bind(this);
        this.checkPin = this.checkPin.bind(this);
        this.showReturnForm = this.showReturnForm.bind(this);
        this.showPrintLabel = this.showPrintLabel.bind(this);
        this.loadTransaction = this.loadTransaction.bind(this);
        this.showPaymentType = this.showPaymentType.bind(this);
        this.isVoidTransactionDisabled = this.isVoidTransactionDisabled.bind(this);
    }

    componentDidMount() {
        var self = this;

        this.loadTransaction();

        // $('.profile-sidebar').css({'display':'none'});
    }

    componentWillUnmount() {
        // $('.profile-sidebar').css({'display':'block'});
    }

    loadTransaction() {
        var self = this;

        var item = this.props.selected;
        
        this.setState({ loading : true }, () => {

            RSVP.all([
                AjaxPromises.POST(PosEndPoints.TRANSACTION_DETAILS, UserStore.getApiData({ TransactionId : item.PosId })),
                AjaxPromises.POST(PosEndPoints.TRANSACTION_ACTIONS, UserStore.getApiData({ TransactionId : item.PosId })),
            ]).then(res => {
                if (res.Result === 'false') {
                    NotificationActions.addNotification({
                        type : 'error',
                        body : 'Could not load transaction '+item.PosId,
                    });
                } else {
                    for (var i=0; i<res[0].Data.length; i++)
                        res[0].Data[i].uuid = res[0].Data[i].PosId;

                    for (var i=0; i<res[1].Data.length; i++)
                        res[1].Data[i].uuid = uuid();

                    self.setState({
                        transaction : res[0].Data,
                        actions     : res[1].Data,
                        loading     : false,
                    });
                }
            });
        });
    }

    close() {
        this.props.onClose();
    }

    checkPin() {
        if (!this.registerSelected()) {
            return;
        }

        var self = this;

        var formData = UserStore.getApiData();
        formData.PinCode = this.state.pin;
        this.setState({ suppressVoidTxn: true });

        AjaxPromises.POST(UserEndPoints.CHECK_PIN_NUMBER,
            formData).then(res => {
                if (res.Result && res.Data[0].MgrPermission === true) {
                    self.setState({
                        pinUserId : res.Data[0].UserId,
                    }, () => {                    
                    self.voidTransaction();
                    });                    
                } else {
                    NotificationActions.addNotification({ type : 'alert', body : 'Invalid PIN' });
                    self.setState({ suppressVoidTxn: false });
                }
            }
        );
    }

    // TODO : combine void and unvoid and create component for it
    voidTransaction() {
        if (!UserStore.getState().selectedRegister) {
            NotificationActions.addNotification({ type : 'alert', body : 'Need to select a register first' });
            return;
        }

        if (this.props.selected.hasReturn) {
            NotificationActions.addNotification({ type : 'error', body : 'You cannot void this transaction because it has returned items.' });
            return;
        }

        var self = this;
        var formData = UserStore.getApiData();
        formData.TransactionId = this.props.selected.PosId;
        formData.RegisterId = UserStore.getState().selectedRegister.id;
        formData.PinUserId = this.state.pinUserId;

        AjaxPromises.POST(PosEndPoints.VOID_TRANSACTION,formData).then(res => {
            if (!res.Result) {
                NotificationActions.addNotification({
                    type : 'error',
                    body : res.Message,
                });
            } else {
                NotificationActions.addNotification({
                    type : 'success',
                    body : 'Transaction Voided',
                });
                PosActions.transactionHistory(self.props.guest.Guest_id);
                self.props.onClose();
            }
        });
    }

    showPaymentType() {
        if (!this.registerSelected()) {
            return;
        }
        
        if (this.props.selected.hasAdjustment) {
            NotificationActions.addNotification({
                type : 'error',
                body : 'You cannot change the payment type because this order already has a change payment adjustment.  Please void that adjustment before attempting another.',
            });
            return;
        }

            this.setState({ showChangePaymentType : true });
    }


    showReturnForm() {
        if (!this.registerSelected()) {
            return;
        }

        if (!this.state.selected)
            return;

        if (this.props.selected.isVoided) {
            NotificationActions.addNotification({
                type : 'error',
                body : 'You cannot return items from an order that has been voided.',
            });
            return;
        }
    
            
        this.setState({ showReturnForm : true });
    }

    isVoidTransactionDisabled() {
        return !!this.state.suppressVoidTxn || !this.state.pin || this.state.selected.PosStatus === 'Returned'
    }

    showPrintLabel() {
        if (!this.state.selected)
            return;

        this.setState({ showPrintLabel : true });
    }

    registerSelected() {
        var selected = false;
        if (!UserStore.getState().selectedRegister) {
            NotificationActions.addNotification({
                type : 'alert',
                body : 'Please select a register first',
            });
        } else {
            selected = true;
        }

        return selected;
    }


    render() {
        var self = this;
 
        var transaction = this.state.transaction || [];
        var actions = this.state.actions || [];
        var selected = this.state.selected;
        var location = UserStore.getState().selectedLocation;
        var lspId = UserStore.getState().user.LspId;
        
        return (
            <div className='popup popup__transparent'>
                <div className='popup__content transaction'>

                    <div className='popup-header'>
                        TRANSACTION DETAILS

                        <div
                            className='popup-close'
                            onClick={this.close}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <div className='transaction__content'>
                        { !this.state.showActions ?
                            <table className='table-1'>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Serial No</th>
                                        <th>Quantity</th>
                                        <th>Unit Price</th>
                                        <th>Description</th>
                                        <th>Product SKU</th>
                                        <th>Lot No</th>
                                        <th>RX No</th>
                                        <th>Instructions</th>
                                        <th>Status</th>
                                        <th>Weight (g)</th>
                                        <th>Return</th>
                                        {UserStore.getState().selectedLocation.PackageItemIds &&
                                            <th>Item Id</th>
                                        }
                                    </tr>
                                </thead>
                                <tbody>

                                    { transaction.map((item, i) => {
                                        return (
                                            <tr
                                                style={(selected && selected.uuid === item.uuid ? { 'backgroundColor' : '#FFED00' } : {})}
                                                key={item.uuid}
                                                id={item.uuid}
                                                onClick={() => { self.setState({ selected : item }); }}>

                                                <td>{moment(item.PosDate).format('D MMM Y')}</td>
                                                <td className='txt-right'>{item.SerialNo}</td>
                                                <td className='txt-right'>{item.Quantity}</td>
                                                <td className='txt-right'>{item.UnitPrice}</td>
                                                <td>{item.ProductDesc}</td>
                                                <td className='txt-right'>{item.ProductSku}</td>
                                                <td>{item.LotNo}</td>
                                                <td>{item.PrescriptionNumber}</td>
                                                <td>{item.Instructions}</td>
                                                <td>{item.PosStatus}</td>
                                                <td className='txt-right'>{item.Equivalent}</td>
                                                <td>{item.ReturnBy} 
                                                {item.ReturnBy && item.ReturnReason ? ': ' : ''}
                                                {item.ReturnReason}</td>
                                                {UserStore.getState().selectedLocation.PackageItemIds &&
                                                    <td>{item.PackageItemId}</td>
                                                }
                                            </tr>
                                        );
                                    })}

                                </tbody>
                            </table>
                        :
                            <table className='table-1'>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Action</th>
                                        <th>User</th>
                                        <th>Comment</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    { actions
                                        .map((action, i) => {
                                                // style={(selected && selected.uuid === item.uuid ? { 'backgroundColor' : '#FFED00' } : {})}
                                        return (
                                            <tr
                                                key={action.uuid}
                                                id={action.uuid}>

                                                <td>{moment(action.TransactionDate).format('D MMM Y - hh:mm:ss')}</td>
                                                <td>{action.TransactionAction}</td>
                                                <td>{action.FullName}</td>
                                                <td>{action.TransactionComment}</td>
                                            </tr>
                                        );
                                    })}

                                </tbody>
                            </table>
                        }

                    </div>

                    <div className='transaction__footer'>
                        <div
                            className='btn-green mr-4'
                            onClick={() => { this.setState({ showEmailReceipt : true }); }}>

                            Email Receipt
                        </div>

                        <div
                            className='btn-green'
                            onClick={() => { PrintActions.printReceipt(this.props.selected.PosId.toString(), true, 'Transaction History'); }}>

                            Print Receipt
                        </div>
                    
                        <select
                            className={'dd-base transaction__select' + (!selected ? '--disabled' : '')}
                            disabled={!selected}
                            value='Actions'
                            onChange={e => { 
                                switch(e.target.value) {
                                case 'PrintLabel':
                                    this.showPrintLabel();
                                    break;
                                case 'Return':
                                    this.showReturnForm();
                                    break;
                                case 'ChangePayment':
                                    this.showPaymentType();
                                    break;
                                }
                             }}
                            style={{display: 'inline-block', width: 'auto', marginLeft: '18px'}}
                            >

                            <option value='Actions' style={{display: 'none'}}>
                                Transaction Actions
                            </option>

                            <option value='PrintLabel'>
                                Print Label
                            </option>
                            { !selected.ReturnBy && !selected.ReturnReason &&

                                [
                                    <option value='Return'>
                                        Return
                                    </option>,                          
                                    <option value='ChangePayment'>
                                        Change Payment
                                    </option>,
                                ]
                            }
                        </select>

                        { location.ShowManifest &&
                            <div
                                className={'btn-green transaction__return'}
                                onClick={() => { PopupActions.openDelivery(this.props.guest, this.props.selected.PosId); }}>

                                Manifest
                            </div>
                        }

                        <div
                            className={'btn-green transaction__return'}
                            onClick={() => { this.setState({ showActions : !this.state.showActions }); }}>

                            { this.state.showActions ? 'Transactions' : 'History' }
                        </div>

                        <div className='transaction__footer--void'>
                            <input
                                type='password'
                                value={this.state.pin}
                                placeholder='PIN'
                                onChange={(e) => { this.setState({ pin : e.target.value }); }} />


                            <button
                                className={`btn btn-green ${this.isVoidTransactionDisabled() ? 'btn-green__disabled' : ''}`}
                                id='btnVoidTxn'
                                onClick={this.checkPin}
                                disabled={this.isVoidTransactionDisabled()}
                            >
                                Void Transaction
                            </button>
                        </div>
                    </div>

                    { this.state.showEmailReceipt &&
                        <div className='popup popup__transparent'>
                            <div className='popup__content w-25'>
                                <div className='popup-header'>
                                    Email Receipt
                    
                                    <div className='popup-close'
                                        onClick={() => { PopupActions.close(); }}>
        
                                        <i className='fa fa-times' aria-hidden='true' />
                                    </div>
                                </div>
                    
                                <EmailReceipt
                                    ShipmentId={this.props.selected.PosId}
                                    email={this.props.guest.Email}
                                    onDone={() => { this.setState({ showEmailReceipt: false });}} />
                            </div>
                        </div>
                    }


                    { this.state.showReturnForm &&
                        <ReturnForm
                            guest={this.props.guest}
                            selected={this.state.selected}
                            onBack={() => { this.setState({ showReturnForm : false, selected: false }); }}
                            onReturn={() => { this.setState({ showReturnForm : false, selected: false }, () => { self.loadTransaction(); }); }} />
                    }

                    { this.state.showChangePaymentType &&
                        <ChangePaymentTypeForm
                            guest={this.props.guest}
                            transaction={this.props.selected}
                            items={this.state.transaction}
                            onBack={() => { this.setState({ showChangePaymentType : false, selected: false }); }}
                            onPaymentChange={() => { this.setState({ showChangePaymentType : false, selected: false }, () => { 
                                PosActions.transactionHistory(self.props.guest.Guest_id);
                                self.close(); 
                            }); 
                            }} />
                    }

                    { this.state.showPrintLabel &&
                        <PrintLabel
                            guest={this.props.guest}
                            selected={this.state.selected}
                            onBack={() => { this.setState({ showPrintLabel : false }); }} />

                    }


                </div>
            </div>
        );
    }
}

export default Transaction;

/*



*/



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/Transaction.react.jsx